import Promise from 'promise-polyfill'
import 'scrolling-element'
import 'lazysizes'
import 'lazysizes/plugins/bgset/ls.bgset.min'
import 'lazysizes/plugins/parent-fit/ls.parent-fit.min'
import 'picturefill'

(function(window, document) {
  const htmlEl = document.querySelector('html')

  if (!window.Promise) {
    window.Promise = Promise
  }
  htmlEl.classList.remove('no-js')
})(window, document)
